export const VLP_PATH = "cars";

const isVehicleListingPage = (pathname: string) => {
  return pathname.split("/")[1] === VLP_PATH;
};

export default isVehicleListingPage;
